import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_learning/discover/(deprecated)/')({
  beforeLoad: () => {
    throw redirect({
      to: '/discover/channels',
    })
  },
})
